import React from "react";
import { Typography } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";

import classes from "./global-search.module.css";

interface RecentSearch {
  label: string;
  query: string;
}

// TODO: replace with the user's real recent searches.
const RECENT_SEARCHES: RecentSearch[] = [
  { label: "Chris Stone", query: "Chris Stone" },
  { label: "Manual VOB #14265", query: "14265" },
  { label: "Estimate #29104", query: "29104" },
];

interface GlobalSearchRecentProps {
  onSelect: (query: string) => void;
}

const GlobalSearchRecent = ({ onSelect }: GlobalSearchRecentProps) => (
  <>
    <div className={classes.sectionLabel}>Recent searches</div>
    <div className={classes.recentList}>
      {RECENT_SEARCHES.map((item) => (
        <div
          key={item.label}
          className={classes.recentItem}
          role="button"
          tabIndex={0}
          onClick={() => onSelect(item.query)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onSelect(item.query);
            }
          }}
          test-id="global-search-recent-item"
        >
          <HistoryIcon fontSize="small" className={classes.chevron} />
          <Typography variant="body2">{item.label}</Typography>
        </div>
      ))}
    </div>
  </>
);

export default GlobalSearchRecent;
